export { default } from './OtpInput';
export * from './OtpInput';
